import React from "react";
import styled from "styled-components";

// components
import Edit, { Image as EditIcon } from "core/ReusableIcons/Edit";

// styles
import colors from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";
export const IconEditStyled = styled.div`
    flex: 0 0 ${convertPxToRem(16)};
    display: flex;
    justify-content: center;
    align-items: center;

    ${EditIcon} {
        width: ${convertPxToRem(16)};
        height: ${convertPxToRem(16)};

        position: relative;
        top: -${convertPxToRem(2)};
        path {
            fill: ${colors.accent.lightMode.persian};
        }
    }
`;

// component
export const IconEdit = () => {
    return (
        <IconEditStyled>
            <Edit />
        </IconEditStyled>
    );
};

export default IconEdit;
